export const getAllDoctorsList = () => {
  return fetch(
    `${process.env.REACT_APP_DATABASEURL}/api/v2/doctorConsultation/doctor/admin/get/list`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    }
  )
    .then(res => {
      return res.json();
    })
    .catch(e => console.log(`error at getting  Categories list ${e}`));
};

export const CreateDoctorProfile = body => {
  return fetch(
    `${process.env.REACT_APP_DATABASEURL}/api/v2/doctorConsultation/doctor/create`,
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    }
  )
    .then(res => {
      return res.json();
    })
    .catch(e => console.log(`error at Create  category ${e}`));
};

export const getDoctorById = Id => {
  return fetch(
    `${process.env.REACT_APP_DATABASEURL}/api/v2/doctorConsultation/doctor/admin/get/${Id}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        // Authorization: `Bearer ${token}`
      },
    }
  )
    .then(res => {
      return res.json();
    })
    .catch(e => console.log(`error at get Doctor by Id ${e}`));
};
export const updateDoctor = (body,id) => {
  return fetch(
    `${process.env.REACT_APP_DATABASEURL}/api/v2/doctorConsultation/doctor/update/${id}`,
    {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    }
  )
    .then(res => {
      return res.json();
    })
    .catch(e => console.log(`error at update parent category ${e}`));
};